import React from "react";
import ImageFileInput from "components/ImageFileInput";

const UserInfoPhotoUpload = ({
  filters,
  boxName,
  isCannotEdit,
  isYourProfile,
  handleEvents,
}) => {
  const addClassImageCircle = filters?.current_active === "Y" ? " active" : "";
  const photoData =
    filters?.photo?.length > 0
      ? {
          url: filters.photo[0]?.data_url || null,
          name: filters.photo[0]?.name || null,
          isBlob: filters.photo[0]?.data_url?.includes("blob:") || false,
        }
      : { url: null, name: null, isBlob: false };

  return (
    <div
      className={`${boxName} row`}
      id={`${boxName}-upload-photo`}
      key={`${boxName}-upload-photo`}
    >
      <div id={`${boxName}-inner-upload-photo`}>
        {photoData.url === null && (
          <div className={`image-circle${addClassImageCircle}`}>
            <i className="material-icons">person</i>
          </div>
        )}
        {photoData.url !== null && !photoData.isBlob && (
          <div
            key={"photo-0"}
            className={`image-circle${addClassImageCircle}`}
            style={{
              background: `url('${photoData.url}') no-repeat center`,
              backgroundSize: "cover",
            }}
          />
        )}
        {photoData.url !== null && photoData.isBlob && (
          <div key={"photo-0"} className={`image-circle${addClassImageCircle}`}>
            <img src={photoData.url} alt="" />
          </div>
        )}
        <div className="image-detail">
          <span style={{ display: "block", fontWeight: "700" }}>
            {filters?.full_name || ""}
          </span>
          <span
            style={{
              display: "block",
              fontWeight: "500",
              marginTop: "0px",
              color: "#5a5a5a",
            }}
          >
            {filters?.position}
            {filters?.dept_names ? ` - ${filters.dept_names.join(", ")}` : ""}
          </span>
          <span id="upload-photo-name">
            {photoData.name !== null ? `Uploaded file : ${photoData.name}` : ""}
          </span>
        </div>
        {(!isCannotEdit || isYourProfile) && (
          <ImageFileInput
            addon={{ multiple: false }}
            handleEvents={handleEvents}
          />
        )}
      </div>
    </div>
  );
};

export default UserInfoPhotoUpload;
